import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import dayjs from 'dayjs'

import { IncidentReportFetchStatisticsResponse } from '@lmc/ts-common'

export const useDashboardIncidents =
  (): IncidentReportFetchStatisticsResponse => {
    const queryParams = getQueryParams(
      {
        fromDate: dayjs().subtract(30, 'days').endOf('day').toISOString(),
        toDate: dayjs().endOf('day').toISOString(),
      } || {}
    )

    const GET_DASHBOARD_INCIDENTS = `/api/list/incident-report/status-count`

    const { data } = useQuery(
      ['status-count'],
      () =>
        getJSON({
          url: `${GET_DASHBOARD_INCIDENTS}?${queryParams}`,
        }),
      { enabled: true }
    )

    return data?.data
  }
